import { DataTableMeta, Switch, Typography } from '@otp/ui';
import { TFunction } from 'i18next';
import {
  NotificationChannel,
  NotificationEventType,
  NotificationUnsubscribe,
} from 'src/graphql/generated/graphql';

export const getTableConfig = (
  data: NotificationEventType[],
  {
    t,
    channels,
    unsubscribes,
    onUnsubscribeChange,
  }: {
    t: TFunction;
    channels: NotificationChannel[];
    unsubscribes: Partial<NotificationUnsubscribe>[];
    onUnsubscribeChange: (
      create: boolean,
      eventTypeId: string,
      channelId: string,
    ) => void;
  },
) => [
  {
    name: 'name',
    label: t('columns.name'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const item = data[column.rowIndex];

        return (
          <div>
            <Typography variant="subtitle1">{item.name}</Typography>
            <Typography variant="subtitle2">{item.description}</Typography>
          </div>
        );
      },
    },
  },
  ...channels.map((channel) => ({
    name: channel.enum,
    label: channel.name,
    options: {
      setCellHeaderProps: () => ({ width: '50px', align: 'center' }),
      setCellProps: () => ({ align: 'center' }),
      customBodyRender: (_: any, column: DataTableMeta) => {
        const isSubscribed = !unsubscribes.find(
          (unsubscribe) =>
            unsubscribe.eventTypeId === data[column.rowIndex].id &&
            unsubscribe.channelId === channel.id,
        );

        const onChange = async (_: any, checked: boolean) => {
          onUnsubscribeChange(!checked, data[column.rowIndex].id, channel.id);
        };

        return <Switch checked={isSubscribed} onChange={onChange} />;
      },
    },
  })),
];
